import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('add_rejected_note_to_cin_core_po_memo'),
    subtitle: defineMessage('automatically_add_a_rej_rejected_in_approvalmax'),
    optionTrue: defineMessage('yes_add_the_prefix'),
    optionFalse: defineMessage('no_do_not_add_the_prefix'),
};
